//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';

//-- Custom
import config from '../../config';
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import DeletePopup from "../Common/Popup/DeletePopup";
import ViewPopup from "../Common/Popup/ViewPopup";
import EditPopup from "../Common/Popup/EditPopup";
import { userActions } from "../../_actions";
import { shopActions } from "../../_actions";

class Shopkeeper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            getCouponList: [],
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            advertisments: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
            shopKeeperAdd: false,
            shopKeeperData: [],
            perPage: config.perPageData,
            roleType: 'shopkeeper',
        };
    }

    /*
    * componentDidMount - Initially it will call and get the advertisments data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(shopActions.getAllShopKeeper(apiConstants.GET_SHOP_AND_SHOPKEEPER, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        if (props.getShopAndShopkeeperList) {
            const receivedShopData = props.getShopAndShopkeeperList.getShopAndShopkeeperList
            if (receivedShopData.data !== undefined && receivedShopData.pagination !== undefined) {
                this.setState({
                    shopKeeperData: receivedShopData,
                    totalPage: receivedShopData.pagination.totalPages,
                    totalDataCount: receivedShopData.pagination.totalCount,
                })
            }
        }
    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(shopActions.getAllShopKeeper(apiConstants.GET_SHOP_AND_SHOPKEEPER, postData));
    }


    changeTableData = (e) => {
        const { dispatch } = this.props;

        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = parseInt(e.target.value);

        dispatch(shopActions.getAllShopKeeper(apiConstants.GET_SHOP_AND_SHOPKEEPER, postData));
    }
    /*
    * searchShopKeepers - User can search data from the database and it will appear
    */
    searchShopKeepers(keyword) {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;


        if (keyword.target.value !== '') {
            postData.search = keyword.target.value;
            dispatch(shopActions.getAllShopKeeper(apiConstants.FIND_SHOP_AND_SHOPKEEPER, postData));
        } else {
            dispatch(shopActions.getAllShopKeeper(apiConstants.GET_SHOP_AND_SHOPKEEPER, postData));
        }
    }

    //-- Popup Handler
    /*
    *   Modal open-close functionality
    */
    popupOpen = (advertisments, type, btnClick) => {
        //-- check add button clicked
        if (btnClick === 'addButton') {
            this.setState({ addButton: true });
            this.setState({ popupType: 'AddShopkeeper' })
        }
        //this.setState({ advertisments, [type]: true })
    };

    EditPopupOpen = (couponData, type) => {
        this.setState({
            data: couponData,
            popupType: 'EditCoupon',
            addButton: true
        });

        this.setState({ [type]: true })
    }


    DeletePopupOpen = (couponId, type) => {
        this.setState({
            deleteId: couponId
        });

        this.setState({ [type]: true })
    }
    /*
    *   Close the popup
    */
    popupClose = (type) => {
        this.setState({
            advertisments: {
                title: '',
                type: '',
                advertisment_image: '',
            },
            addButton: false,
            [type]: false
        });
    };

    /*
    *   We are handling validation from this function
    */
    handleValidation(data) {
        const { siteConstants } = this.props.language;

        let fields = data.defaultData;
        let errors = {};
        let formIsValid = true;
        //Name
        if ((fields["title"] == '')) {
            formIsValid = false;
            if (fields["title"] == '') {
                errors["title"] = siteConstants.ERR_CAN_NOT_BLANK;
            }
        }

        if (!fields["title"]) {
            if (!fields["title"].match(/^[a-zA-Z]+$/)) {
                formIsValid = false;
                errors["title"] = siteConstants.ERR_ONLY_LETTERS;
            }
        }
        return ({ errors, formIsValid });
    }


    //-- handle change of checkbox
    handleChange(e, id) {
        const { dispatch } = this.props;
        this.setState({ isChecked: e.target.checked })
        let postData = {};
        postData.id = id;
        postData.status = e.target.checked;

        let getListData = {};
        getListData.api = apiConstants.GET_SHOP_AND_SHOPKEEPER;
        getListData.page = this.state.currentPage;
        getListData.orderBy = "_id";
        getListData.orderByAscDesc = "ASC";
        getListData.roleType = this.state.roleType;
        getListData.perPage = this.state.perPage;

        dispatch(shopActions.updateShopkeeperStatus(apiConstants.ACTIVE_ACCOUNT, postData, getListData));

    }


    deleteCoupon = (couponId) => {
        let postData = {};
        postData.page = this.state.currentPage;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        let obj = {};
        obj.id = couponId;
        this.props.dispatch(userActions.deleteCoupon(apiConstants.DELETE_COUPON, obj, apiConstants.GET_COUPOUN, postData));
        this.popupClose('deleteOpen');
    }


    openAddShopKeeper = () => {
        this.setState({ shopKeeperAdd: !this.state.shopKeeperAdd })
    }

    handleClose = () => {
        this.setState({ shopKeeperAdd: !this.state.shopKeeperAdd })
    };

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_SHOPKEEPER}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-0 text-gray-800">{siteConstants.MENU_SHOPKEEPER}</h1>
                                <a href="/add-shopkeeper"
                                //onClick={() => this.openAddShopKeeper()}
                                >
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>

                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" placeholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" aria-controls="dataTable" onChange={(e) => this.searchShopKeepers(e)} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>



                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="10%">{siteConstants.GEN_FIRST_NAME}</th>
                                                    <th scope="col">{siteConstants.GEN_LAST_NAME}</th>
                                                    <th width="10%">{siteConstants.GEN_SHOP_TITLE}</th>
                                                    <th scope="col">{siteConstants.GEN_EMAIL_ADDRESS}</th>
                                                    <th scope="col">{siteConstants.GEN_MOBILE_NUMBER}</th>
                                                    <th width="10%">{siteConstants.GEN_ACCOUNT_STATUS}</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            {/* <tfoot>
                                                <tr>
                                                    <th scope="col">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="10%">{siteConstants.GEN_FIRST_NAME}</th>
                                                    <th scope="col">{siteConstants.GEN_LAST_NAME}</th>
                                                    <th width="10%">{siteConstants.GEN_SHOP_TITLE}</th>
                                                    <th scope="col">{siteConstants.GEN_EMAIL_ADDRESS}</th>
                                                    <th scope="col">{siteConstants.GEN_DOB}</th>
                                                    <th scope="col">{siteConstants.GEN_MOBILE_NUMBER}</th>
                                                    <th width="10%">{siteConstants.GEN_ACCOUNT_STATUS}</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </tfoot> */}
                                            <tbody>
                                                {
                                                    this.state.shopKeeperData.data != undefined &&
                                                        this.state.shopKeeperData.data.length > 0 ?
                                                        this.state.shopKeeperData.data.map((thisShopKeeper, index) => {
                                                            // let d = new Date(coupon.expiry);
                                                            // let expiryDate=d.toLocaleDateString();
                                                            let shopTitle = 'NA';
console.log("SSSSSSSSSSSSSSSSSS ",thisShopKeeper);
                                                            if (thisShopKeeper.shopData !== undefined) {
                                                                shopTitle = thisShopKeeper.shopData.map((shop, index) => {
                                                                    return shop.title;
                                                                })
                                                            }

                                                            let editUrl = "/edit-shopkeeper/" + thisShopKeeper._id;
                                                            //let editUrl = "/edit-shopkeeper";
                                                            let viewUrl = '/view-shopkeeper/' + thisShopKeeper._id;;

                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td>{thisShopKeeper.firstname}</td>
                                                                    <td>{thisShopKeeper.lastname}</td>
                                                                    <td>{shopTitle}</td>
                                                                    <td>{thisShopKeeper.email}</td>
                                                                    <td>{thisShopKeeper.mobile_number}</td>
                                                                    <td className="tdTextCenter">
                                                                        <div className="custom-control custom-checkbox small">
                                                                            <input type="checkbox" className="form-check-input" htmlFor="customCheck" id="customCheck"
                                                                                name={['isChecked' + index]} checked={thisShopKeeper.account_activate === 'active'}
                                                                                onChange={(e) => this.handleChange(e, thisShopKeeper._id)} />
                                                                        </div>
                                                                    </td>
                                                                    <td className="tdTextCenter">
                                                                        <a className="actionIcon" title="Edit" href={editUrl}><span><img src="assets/img/svg/EditIcon.png" alt="Edit" /></span></a>
                                                                        <a className="actionIcon" title="View" href={viewUrl} ><span><img src="assets/img/svg/eye-icon.png" alt="View" /></span></a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="8" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* add shop keeper popup */}
                    {/* <AddShopkeeper openPopup={this.state.shopKeeperAdd} handleClose={()=>this.handleClose()}/> */}

                    <Footer />
                </div>

                {/* Start Popup -View advertisments details  */}
                <ViewPopup
                    popupType="AdvertismentsComponenet"
                    viewOpen={this.state.viewOpen}
                    advertisments={this.state.advertisments}
                    funPopupClose={this.popupClose}
                />
                {/* End Popup -View advertisments details  */}

                {/* Start Popup -Edit advertisments details  */}
                {/* <EditPopup 
                 popupType={this.state.popupType}
                 userData={this.state.data}
                 currentPage={this.state.currentPage}
                 addButton={this.state.addButton}
                 editOpen={this.state.editOpen}
                 funPopupClose={this.popupClose}
                 funAdvertismentsAddUpdate={(e, data) => this.advertismentsAddUpdate(e, data)}
                 defaultData={this.state.advertisments}
                /> */}
                {/* End Popup -Edit advertisments details  */}
                {/* Delete popup */}
                <DeletePopup
                    deleteOpen={this.state.deleteOpen}
                    deleteId={this.state.deleteId}
                    funPopupClose={this.popupClose}
                    funDelete={this.deleteCoupon}
                />
            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getCoupounList, language, getShopAndShopkeeperList } = state;
    return {
        getCoupounList,
        language,
        getShopAndShopkeeperList
    };
}

const connectedShopkeeper = connect(mapStateToProps)(Shopkeeper);
export { connectedShopkeeper as Shopkeeper };